import axios from "axios";
import { Message } from "element-ui";
import Cookies from 'js-cookie';
// axios默认配置
axios.defaults.timeout = 1800000; // 超时时间

 
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL || ""; // 生产环境用 .env.production 配置，开发环境用空串走代理


axios.interceptors.request.use(config => {
 
  // NProgress.start() //顶部进度条
  config.headers["Content-Type"] = "application/json;charset=UTF-8"
  
   // if (Cookies.get("token")) {
	  //  config.headers['token'] =  `${Cookies.get("token")}`;
   //   console.log('执行了接口拦截器1',config.headers['token'])
   //     }
  return config
},
  error => {
    return Promise.reject(error.response)
  })


axios.interceptors.response.use(
   
  (response) => {
	  console.log('request.response',response)
    if (response.data.code === 11000) {
      return Promise.resolve(response);
    } else 
	if (response.data.code === 10000) {
      // 约定报错信息
      Message({
        message: response.data.message,
        type: "warning",
      });
      return Promise.reject(response);
    } else {
      return Promise.resolve(response);
	  
    }
  },
  (error) => {
	  console.log('error',error,error.response.status)
		  if (error.response.status === 404) {
      Message({
        message: "请求地址出错",
        type: "warning",
      });
    }
	 else if (error.response.status === 401) {
	 	console.log('执行到这里了11')
	   Message({
	     message: "接口返回错误",
	     type: "warning",
	   });
	   // setTimeout(() => {
	   //   location.reload();
	   // }, 3000);
	 }
	 else if (error.response.status === 0) {
		console.log('执行到这里了12')
      Message({
        message: "接口返回错误",
        type: "warning",
      });
      // setTimeout(() => {
      //   location.reload();
      // }, 3000);
    }
	
    return Promise.reject(error.response); // 返回接口返回的错误信息
  }
);
export default axios;


